import {hasValidString} from '../../utils/utils'

const LEAP_MESSAGE_BAR = 'leap-message-bar'

/**
 * The messages of a message bar that render as a slide
 *
 * @param {Array<Object>} [messages] - The module's messages.
 * @returns {Array<Object>} The messages that render as a slide.
 */
export const getValidSlides = (messages) =>
    Array.isArray(messages) ? messages.filter((message) => hasValidString(message?.copy?.text)) : []

/**
 * Whether any slide carries a CTA. A single CTA sets the taller mobile bar for all
 * slides, so the bar does not jump between them.
 *
 * @param {Array<Object>} slides - The slides, as returned by `getValidSlides`.
 * @returns {boolean} True if any slide carries a CTA label.
 */
export const hasSlideWithCta = (slides) => slides.some((slide) => hasValidString(slide.cta?.label))

/**
 * The first message bar with slides among a slot's Leap modules
 *
 * @param {Array<Object>|string} [body] - The slot's `c_body`, Leap modules or legacy HTML.
 * @returns {{modules: Array<Object>, hasCta: boolean}|null} The message bar module and
 * whether any of its slides carries a CTA, or `null` when no message bar has slides.
 */
export const findMessageBar = (body) => {
    for (const module of Array.isArray(body) ? body : []) {
        const slides =
            module?.moduleType === LEAP_MESSAGE_BAR ? getValidSlides(module.messages) : []
        if (slides.length > 0) {
            return {modules: [module], hasCta: hasSlideWithCta(slides)}
        }
    }
    return null
}
